import {
  PIPE_SWITCH_THERMOPLASTIC_LINTER,
  PIPE_CALCULATIONS_SET_PARAMETER_VALUE, IS_DIRTY,
} from "../lib/types";

export const setPipeParameterValue = (parameter, value) => (dispatch, getState) => {
  dispatch({
    type: PIPE_CALCULATIONS_SET_PARAMETER_VALUE,
    payload: {
      parameter,
      value,
    },
  });
  dispatch({
    type: IS_DIRTY,
    payload: true,
  });

  return getState().pipeGlobals[parameter];
};

export const switchThermoplasticLinter = () => dispatch => {
  dispatch({
    type: PIPE_SWITCH_THERMOPLASTIC_LINTER
  });
};



// WEBPACK FOOTER //
// ./src/actions/pipe-calculations.actions.js